// extracted by mini-css-extract-plugin
module.exports = {"sponsor_box":"sponsor_box___3OzD3","home_img_1":"home_img_1___fiG0N","data_box":"data_box___3DKVE","cycle_item":"cycle_item___2va0m"};